import React from 'react';
import './banner.css';

function ICIPBanner(props) {
  const { bannerText } = props;
  return (
    <React.Fragment>
    <div className="helpLinks">
        <a href="https://t.corp.amazon.com/create/templates/d898c25f-7edc-492b-be79-ca996da98c07" target="_blank">Cut a ticket</a>
        <a href="https://console.harmony.a2z.com/internal-ai-assistant?persona=e04713bf-1fd8-4027-9d96-d11f0e777b17" target="_blank">Need help? Chat with Our Cedric Persona</a>
    </div>
    <div className="ICIPBanner">
      <h1>{bannerText}</h1>
    </div>
    </React.Fragment>
  );
}

export default ICIPBanner;